<template>
  <div id="app">
    <headers activeIndex="/courseware"></headers>
    <!-- <headers :activeIndex="'/courseware':'/allList'"></headers> -->
    <div class="course-box" v-if="det">
      <div class="w_1605">
        <div class="course-box-title">
          <a href="javascript:history.back(-1)"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
          {{det.name}}
        </div>

        <div class="course-box-content">
          <div class="course-box-content-left" style="">
            <!-- <i class="iconfont icon-start" v-if="isplay" style="width: 100%;height: 100%;flex-wrap: wrap;"></i> -->
            <!-- <iframe src="//vpn.file.laodongjiaoyu.vip/uploads/20230311/de2b7163ca4b5ebfcbd0ee08c07080d9.mp4" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe> -->
            <iframe frameborder="0" :src="url" allowFullScreen="true"
              :style="'width: 100%;height: 100%;min-height: 740px;background: url('+det.image+') no-repeat;background-size:100%'" @click="isplay=false" v-if="url.indexOf('.jpg')==-1&&url.indexOf('.png')==-1"></iframe>
              <el-image
                  style="width: auto;height: 740px;margin: 0 auto;display: block;"
                  :src="url"
                  fit="scale-down"
                  :preview-src-list="imglist" v-else>
                </el-image>
          </div>

          <div class="course-box-content-right">

            <div class="course-list">
              <h2>目录</h2>
              <ul class="ul-div">
                <el-menu default-active="2" class="el-menu-vertical-demo" background-color="rgba(0,0,0,0)"
                  @select="handleSelect">
                  <el-submenu index="0">
                    <template slot="title">
                      <i class="iconfont icon-Vector"></i>
                      <span>课程简介</span>
                    </template>
                    <el-menu-item-group>
                      <div v-html="det.content"></div>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="1">
                    <template slot="title">
                      <i class="iconfont icon-Frame"></i>
                      <span>说课视频</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.video" :key="item.id" :index="'1-'+key">{{item.name}}
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="2" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-Frame"></i>
                      <span>示范课视频</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.demovideo" :key="item.id" :index="'2-'+key">{{item.name}}
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="3" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>教案</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.teachingplan" :key="item.id" :index="'3-'+key">
                        {{item.name}}
                        <i class="iconfont icon-Frame1" @click="downfile(item.fileurl)"></i>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="4" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>课件</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.courseware" :key="item.id" :index="'4-'+key">{{item.name}}
                      <i class="iconfont icon-Frame1" @click="downfile(item.fileurl)"></i>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="5" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>学生用书</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.studentbook" :key="item.id" :index="'5-'+key">{{item.name}}
                      <i class="iconfont icon-Frame1" @click="downfile(item.fileurl)"></i>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="6" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>教师用书</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.teacherbook" :key="item.id" :index="'6-'+key">{{item.name}}
                      <i class="iconfont icon-Frame1" @click="downfile(item.fileurl)"></i>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="7" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-Frame"></i>
                      <span>多媒体素材</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.multimedia" :key="item.id" :index="'7-'+key">{{item.name}}
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="8" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>教具清单</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.teachinglist" :key="item.id" :index="'8-'+key">
                        {{item.name}}
                        <i class="iconfont icon-Frame1" @click="downfile(item.fileurl)"></i>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="9" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>评估工具</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.tool" :key="item.id" :index="'9-'+key">{{item.name}}
                      <i class="iconfont icon-Frame1" @click="downfile(item.fileurl)"></i>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="s" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>我的文件</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.file" :key="item.id" :index="'s-'+key">{{item.name}}
                      <i class="iconfont icon-Frame1" @click="downfile(item.fileurl)"></i>
                      <i class="el-icon-delete" @click="open(item)"></i>
                      </el-menu-item>

                      <el-upload class="upload-demo" :action="baseUrl+'teacher/common/upload'" :headers="{token}"
                        :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                        :on-success="filesuccess" multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
                        <el-button size="small" type="primary">上传</el-button>
                      </el-upload>
                      <!-- <el-button type="primary" @click="dialogFormVisible=true">上传<i
                          class="el-icon-upload el-icon--right"></i></el-button> -->
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title="" :visible.sync="dialogFormVisible" width="30%" :before-close="handleCloses">
        <el-image style="width: 60px; height: 60px;font-size: 22.5px;" :src="iconurl">
        </el-image>
        <h4 style="margin: 25px 0 10px 0;">上传资料</h4>
        <span style="margin-bottom: 10px;">点击上传该课程文件所需的资料</span>
        <el-input v-model="form.name" autocomplete="off"></el-input>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
          <el-button @click="dialogFormVisible = false">再看看</el-button>
          <!-- <el-upload class="upload-demo" :action="baseUrl+'teacher/common/upload'" :headers="{token}"
            :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
            :on-success="filesuccess" multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">上传</el-button>
          </el-upload> -->
          <el-button type="primary" @click="clicksubmit()">确 定</el-button>
        </span>
      </el-dialog>


    </div>
    <!-- <footers></footers> -->
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import axios from 'axios';
  import {
    coursedetail,
    teachercoursedetail,
    uploadFile,
    delFile
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      // footers
    },
    data() {
      return {
        det: '',
        url: '',
        iconurl:require('../../assets/images/success.png'),
        dialogFormVisible: false,
        form: {
          course_id: '',
          name: '',
          fileurl: ''
        },
        token: '',
        formLabelWidth: '120px',
        fileList: [],
        baseUrl: '',
        isplay:true,
        imglist:[]
      }
    },
    methods: {
      open(item) {
        let text='确认删除吗'+item.name
        this.$alert(text, '是否删除', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action)
            if(action=='confirm'){
              this.delfile(item.id)
            }
          }
        });
      },
      delfile(id){
        let data={
          file_id:id
        }
        delFile(data).then(res=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          setTimeout(() => {
            location.reload();
          }, 1500)
        })
      },
      downfile(url){
        window.open(url,"_blank")
      },
      handleCloses(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.dialogFormVisible = false
          })
          .catch(_ => {});
      },
      clicksubmit() {
        this.dialogFormVisible = false
        uploadFile(this.form).then(res => {
          this.$message({
            message: res.msg,
            type: res.code ? 'success' : 'error'
          });

          setTimeout(() => {
            location.reload();
          }, 1500)
        })
      },
      filesuccess(file) {

        this.form.fileurl = file.data.fullurl
        this.dialogFormVisible = true
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath, parseInt(key.slice(2)));
        let type = {
          '1': 'video',
          '2': 'demovideo',
          '3': 'teachingplan',
          '4': 'courseware',
          '5': 'studentbook',
          '6': 'teacherbook',
          '7': 'multimedia',
          '8': 'teachinglist',
          '9': 'tool',
          's': 'file',
        }
        if(this.det[type[keyPath[0]]][parseInt(key.slice(2))].videourl){
          this.url = this.det[type[keyPath[0]]][parseInt(key.slice(2))].videourl
        }else{
          if(this.det[type[keyPath[0]]][parseInt(key.slice(2))].fileurl.indexOf('.ppt')!=-1){
            this.url = 'https://view.officeapps.live.com/op/view.aspx?src='+this.det[type[keyPath[0]]][parseInt(key.slice(2))].fileurl
          }else{
            this.url = this.det[type[keyPath[0]]][parseInt(key.slice(2))].fileurl
            this.imglist[0]=this.det[type[keyPath[0]]][parseInt(key.slice(2))].fileurl
          }
        }
        // this.url = this.det[type[keyPath[0]]][parseInt(key.slice(2))].videourl ? this.det[type[keyPath[0]]][parseInt(key
        //   .slice(2))].videourl : this.det[type[keyPath[0]]][parseInt(key.slice(2))].fileurl
        // this.det.video
      },
      editurl(url) {

      }
    },
    created() {
      console.log(this.$router)
      this.token = localStorage.getItem('token')
      this.form.course_id = this.$route.query.id
      this.baseUrl = axios.defaults.baseURL
      teachercoursedetail({
        course_id: this.$route.query.id
      }).then(res => {
        if(res.code){
          this.det = res.data
          // this.url = this.det.video[0].videourl
        }else{
          this.$message({
            message: res.msg,
            type: 'error'
          });
          this.$router.go(-1)
        }
      })
    }
  }
</script>

<style scoper>
  @import '../../assets/css/home.css';

  .ul-div .el-menu-item.is-active {
    background-color: #22AC38 !important;
    color: #fff !important;
  }

  .dialog-footer {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: inline-block;
  }

  .dialog-footer .el-button {
    width: 48%;
    float: left;
  }

  .dialog-footer .upload-demo {
    width: 48%;
    float: right;
  }

  .dialog-footer .upload-demo .el-upload {
    width: 100%;
  }

  .dialog-footer .upload-demo .el-button {
    width: 100%;
    height: 40px;
    background: #22AC38;
    border: #22AC38;
  }

  .el-dialog {
    width: 460px;
    border-radius: 20px;
  }
  .el-icon-delete{
    float: right;
    line-height: 50px;
    color: brown !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/coursewaredet.vue